import React from 'react';
import ProductGroupEditView from 'domains/productGroup/components/ProductGroupEditView';

const ProductGroupEditPage: React.FC = () => {
  return <ProductGroupEditView />;
};

export default ProductGroupEditPage;